import { TABLE_DEFAULT_LIMIT } from '../util/constant';

export const getQueryParams = (form, currentPage, conditionType) => {
  const queryParams = {};
  if (form.getValues('locationId')) {
    queryParams.locationId = form.getValues('locationId');
  }
  if (form.getValues('query')) {
    queryParams.query = form.getValues('query');
  }
  if (form.getValues('dateFrom')) {
    queryParams.dateFrom = form.getValues('dateFrom');
  }
  if (form.getValues('dateTo')) {
    queryParams.dateTo = form.getValues('dateTo');
  }
  if (form.getValues('invoiceStartDate')) {
    queryParams.invoiceStartDate = form.getValues('invoiceStartDate');
  }
  if (form.getValues('invoiceEndDate')) {
    queryParams.invoiceEndDate = form.getValues('invoiceEndDate');
  }
  if (form.getValues('companyId')) {
    queryParams.companyId = form.getValues('companyId');
  }
  if (form.getValues('kitchenId')) {
    queryParams.kitchenId = form.getValues('kitchenId');
  }
  if (form.getValues('itemId')) {
    queryParams.itemId = form.getValues('itemId');
  }
  if (form.getValues('vendorId')) {
    queryParams.vendorId = form.getValues('vendorId');
  }
  if (conditionType === 'download') {
    queryParams.conditionType = conditionType;
  } else {
    queryParams.page = currentPage;
    queryParams.limit = TABLE_DEFAULT_LIMIT;
  }
  return queryParams;
};
